<template>
  <ValidationProvider :rules="rules" v-slot="{ errors, valid }" :name="errorLabelText">
    <b-field
      :label="label"
      :type="{'is-danger': errors.length }"
      :message="errors[0]"
      custom-class="test-color"
    >
      <b-input size="is-small" v-model="data" :name="name" :type="type"></b-input>
    </b-field>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

/**
 * Custom Form input with validation setup
 */
export default {
  name: "InputWithValidation",
  props: {
    rules: { type: String, required: true },
    model: { type: String | Boolean },
    label: { type: String, default: "" },
    vuexKey: { type: String, required: true },
    name: { type: String, required: true },
    errorLabel: { type: String },
    type: { type: String, default: "text" }
  },

  components: {
    ValidationProvider
  },

  data() {
    return {
      data: this.model,
      booleanOptions: [
        { id: 1, value: true, label: "YES" },
        { id: 2, value: false, label: "NO" }
      ]
    };
  },

  computed: {
    /**
     * Determine the text to be used as the field name when displaying error messages
     */
    errorLabelText() {
      if (this.errorLabel) {
        return this.errorLabel;
      }

      return this.name;
    }
  },

  methods: {
    onSelect: function(value) {
      this.$emit("input", { key: this.vuexKey, value: this.data });
    }
  },

  watch: {
    /**
     * Emit an input event, so the parent component can handle it appropriately
     */
    data(value) {
      if (!this.isBoolean) {
        this.$emit("input", { key: this.vuexKey, value });
      }
    }
  }
};
</script>


<style scoped>
.test-color {
  color: rgb(83, 83, 83) !important;
}
</style>
